import React from "react";
import { Form } from "@ant-design/compatible";
import "@ant-design/compatible/assets/index.css";
import { Button, Select } from "antd";

const { Option } = Select;

class FormFive extends React.Component {
  render() {
    const { onSubmit, form, signersGroupsGetData } = this.props;
    const { getFieldDecorator } = form;

    const hotelOptions = signersGroupsGetData.grant_access_all_users.map(
      (d) => (
        <Option key={d._id}>
          {d.name} - {d.user_name} - {d.email}
        </Option>
      )
    );

    return (
      <Form
        labelCol={{
          xs: { span: 24 },
          sm: { span: 6 },
          md: { span: 6 },
          lg: { span: 5 },
          xl: { span: 5 },
          xxl: { span: 5 },
        }}
        wrapperCol={{
          xs: { span: 24 },
          sm: { span: 18 },
          md: { span: 18 },
          lg: { span: 15 },
          xl: { span: 12 },
          xxl: { span: 12 },
        }}
        onSubmit={onSubmit}
      >
        <Form.Item label="User(s)">
          {getFieldDecorator("grant_access_users", {
            initialValue:
              signersGroupsGetData && signersGroupsGetData.grant_access_users
                ? signersGroupsGetData.grant_access_users
                : [],
          })(
            <Select
              mode="multiple"
              showSearch
              placeholder="Select User(s)"
              optionFilterProp="children"
              notFoundContent={null}
            >
              {hotelOptions}
            </Select>
          )}
        </Form.Item>

        <Form.Item wrapperCol={{ span: 12, offset: 5 }}>
          <Button type="primary" htmlType="submit">
            Update
          </Button>
        </Form.Item>
      </Form>
    );
  }
}

const WrappedApp = Form.create({ name: "form_two" })(FormFive);

export default WrappedApp;
